export const adminNews = {
  'admin.news.createPost.title': 'Haber Yazısı Oluştur',
  'admin.news.createPost.save': 'Yazıyı Kaydet',
  'admin.news.createPost.saving': 'Kaydediliyor...',
  'admin.news.createPost.success': 'Yazı başarıyla oluşturuldu',
  'admin.news.createPost.error': 'Yazı oluşturulamadı',
  'admin.news.createPost.titlePlaceholder': 'Yazı başlığını girin',
  'admin.news.createPost.descriptionPlaceholder': 'Kısa bir açıklama girin',
  'admin.news.createPost.contentPlaceholder': 'Yazı içeriğinizi buraya yazın...',
  'admin.news.createPost.settings': 'Ayarlar',
  'admin.news.createPost.publish': 'Yayımla',
  'admin.news.createPost.tags': 'Etiketler',
  'admin.news.createPost.selectTags': 'Etiket seçin',
  'admin.news.createPost.videoUrl': 'Video URL',
  'admin.news.createPost.videoUrlPlaceholder': 'YouTube veya Vimeo URL\'si girin',
  'admin.news.createPost.featuredImage': 'Öne Çıkan Görsel',
  'admin.news.createPost.uploadImage': 'Görsel Yükle',
  'admin.news.createPost.removeImage': 'Görseli Kaldır',
  'admin.news.createPost.translations': 'Çeviriler',
  'admin.news.createPost.translate': 'Çevir',
  'admin.news.createPost.translating': 'Çevriliyor...',
  'admin.news.createPost.translationPreview': 'Çeviri Önizleme',
};
